import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-collections',
    templateUrl: './collections.component.html',
    styleUrls: ['./collections.component.scss'],
    standalone: false
})
export class CollectionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
